import { render, staticRenderFns } from "./MobileLanguageSelect.vue?vue&type=template&id=652d43c0&scoped=true&"
import script from "./MobileLanguageSelect.vue?vue&type=script&lang=ts&"
export * from "./MobileLanguageSelect.vue?vue&type=script&lang=ts&"
import style0 from "./MobileLanguageSelect.vue?vue&type=style&index=0&id=652d43c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d43c0",
  null
  
)

export default component.exports